import React from 'react';

import Helmet from 'react-helmet';

import Arrow from 'assets/svg/small-arrow.svg';

import s from './SignUp.scss';

interface IProps {
  label?: string;
  placeholder?: string;
  button?: string;
  children?: React.ReactNode;
}

export const SignUp = ({ label = '', placeholder, button = '', children }: IProps) => {
  return (
    <>
      <Helmet>
        <script
          src="https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"
        >
        </script>
      </Helmet>
      <form
        id="subForm"
        className="js-cm-form"
        action="https://www.createsend.com/t/subscribeerror?description=" method="post"
        // tslint:disable-next-line:max-line-length
        data-id="2BE4EF332AA2E32596E38B640E905619F8F2CDB939683984922F1CFD8744131DA570FF9D3C552A2CEC43DF83537772B6BB5DA6AAF3DB621F00C0CBDEF03AC4CE"
      >
      <div className={s.signUp}>
        <label>
          {label}
          <span className={s.signUp__inner}>
            <input
              id="fieldEmail"
              type="text"
              className={s('signUp__input', 'js-cm-email-input qa-input-email')} placeholder={placeholder} 
              name="cm-wihqt-wihqt"
            />
            <button className={s.signUp__button} type="submit">
              {button} <Arrow className={s.signUp__arrow} />
            </button>
          </span>
        </label>
        {children}
      </div>
    </form>
    </>
  );
};
